import { Alert, AlertIcon, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Asks the reader to check the answer against the source.
 *
 * Shown when a model labelled `hr_verification_warning` in the catalog
 * answered a question the flag pass classified as HR-related. Both halves are
 * explicit policy, so this fires for a chosen model as well as a fallback one.
 */
const VerifySourcesNote: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Alert status='warning' borderRadius='md' mb={2} py={2} fontSize='sm' alignItems='flex-start'>
      <AlertIcon boxSize={4} mt={0.5} />
      <Text>{t('models.verifySources')}</Text>
    </Alert>
  )
}

export default VerifySourcesNote
